export const CART_GET_ASSETS = 'CART_GET_ASSETS';
export const CART_ADD_ASSET = 'CART_ADD_ASSET';
export const CART_REMOVE_ASSET = 'CART_REMOVE_ASSET';

export const GALLERY_RESULTS_AVAILABLE = 'GALLERY_RESULTS_AVAILABLE';
export const GALLERY_CLEAR_SEARCH_PARAMETERS =
  'GALLERY_CLEAR_SEARCH_PARAMETERS';
export const GALLERY_FETCH_PA_AGREEMENTS = 'GALLERY_FETCH_PA_AGREEMENTS';
export const GALLERY_SEARCH = 'GALLERY_SEARCH';
export const GALLERY_SET_ASSET_TYPE_AND_FAMILY =
  'GALLERY_SET_ASSET_TYPE_AND_FAMILY';
export const GALLERY_SET_SEARCH_PARAMETER = 'GALLERY_SET_SEARCH_PARAMETER';
export const GALLERY_TOGGLE_SEARCH_PARAMETER =
  'GALLERY_TOGGLE_SEARCH_PARAMETER';
export const GALLERY_TOGGLE_SEARCH_PARAMETER_VALUES =
  'GALLERY_TOGGLE_SEARCH_PARAMETER_VALUES';
export const GALLERY_FETCH_MORE_EVENTS = 'GALLERY_FETCH_MORE_EVENTS';
export const GALLERY_FETCH_MORE_GATEWAY_ASSETS =
  'GALLERY_FETCH_MORE_GATEWAY_ASSETS';
export const GALLERY_POPULAR_FILTER = 'GALLERY_POPULAR_FILTER';

export const PAGE_STATUS_CHANGED = 'PAGE_STATUS_CHANGED';
export const PAGE_ASSETS_LOADING = 'PAGE_ASSETS_LOADING';

export const SET_SEARCH_PREFERENCES = 'SET_SEARCH_PREFERENCES';

export const FETCH_FACETS = 'FETCH_FACETS';
